import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const SubtractFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.4332 22.0703C17.9042 22.0703 22.4375 17.5437 22.4375 12.0703C22.4375 6.5969 17.8955 2.07031 12.4244 2.07031C6.9582 2.07031 2.4375 6.5969 2.4375 12.0703C2.4375 17.5437 6.96691 22.0703 12.4332 22.0703ZM8.3271 12.8406C7.82651 12.8406 7.46915 12.5663 7.46915 12.0956C7.46915 11.6083 7.80519 11.3252 8.3271 11.3252H16.5527C17.0746 11.3252 17.3972 11.6083 17.3972 12.0956C17.3972 12.5663 17.0533 12.8406 16.5527 12.8406H8.3271Z"
        fill={color}
      />
    </svg>
  );
};

export { SubtractFilledSvg };
